export const DeleteListModal: string = 'DeleteListModal';
